import React from 'react'
import { getSelectionChoices } from 'resources/operations/events/utils'
import { ProductWithUpselling } from 'services/api/entities/catalog/productWithUpsellings/types/internal/productWithUpsellings-models'
import { UpsellingSelection } from 'services/api/entities/events/types/internal/selections'
import { distinctById } from 'services/utils'
import EventBaseSelectionInput, {
  EventBaseSelectionInputProps,
} from './EventBaseSelectionInput'

type EventUpsellingSelectionInputProps = Omit<
  EventBaseSelectionInputProps,
  'label'
> & {
  selectedProduct?: ProductWithUpselling
  upsellingSelection?: UpsellingSelection[]
}

const EventUpsellingSelectionInput: React.FC<
  EventUpsellingSelectionInputProps
> = ({ selectedProduct, upsellingSelection = [], ...rest }) => {
  const choices = distinctById(
    upsellingSelection.flatMap((u) =>
      getSelectionChoices(u, selectedProduct?.upsellingItemsFull)
    )
  )
  return (
    <EventBaseSelectionInput
      {...rest}
      arrayInputLabel="form.fields.upsellingItems"
      label={'form.fields.upsellingItems'}
      choices={choices}
    />
  )
}

export default EventUpsellingSelectionInput
